export default __webpack_public_path__ + "static/media/1.f6bbc1c5.jpg";